import React from 'react';
import logo from '../../../public/assets/images/logo.png';

const Footer = () => {
  return (
    <footer className="footer-wrapper footer-layout1 bg-[]">
      <div className="widget-area">
        <div className="container">
          <div className="newsletter-area">
            <div className="newsletter-top">
              <div className="row gy-4 align-items-center">
                <div className="col-lg-5">
                  <h2 className="newsletter-title text-capitalize mb-0">get updated the latest newsletter</h2>
                </div>
                <div className="col-lg-7">
                  <form className="newsletter-form" onSubmit={(e) => e.preventDefault()}>
                    <input className="form-control" type="email" placeholder="Enter Email" required />
                    <button type="submit" className="th-btn style3">Subscribe Now</button>
                  </form>
                </div>
              </div>
            </div>
          </div>

       
        </div>
      </div>
         <div className="row justify-content-between bg-gradient-to-r from-white/95 to-[#1a237e] py-10 px-4 mx-auto">
            <div className="col-md-6 col-xl-auto">
              <div className="widget footer-widget">
                <div className="th-widget-about">
                  <div className="about-logo ml-2">
                    <a href="#slider-sec">
                      <img style={{ height: '150px', width: '200px', padding: '10px' }} src={logo} alt="Legend Safaris" />
                    </a>
                  </div>
                  <div className="th-social">
                    <a href="https://www.facebook.com/"><i className="fab fa-facebook-f"></i></a>
                    <a href="https://www.twitter.com/"><i className="fab fa-twitter"></i></a>
                    <a href="https://www.linkedin.com/"><i className="fab fa-linkedin-in"></i></a>
                    <a href="https://www.whatsapp.com/"><i className="fab fa-whatsapp"></i></a>
                    <a href="https://instagram.com/"><i className="fab fa-instagram"></i></a>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-xl-auto">
              <div className="widget footer-widget">
              
                <div className="th-widget-contact mt-26">
                  <div className="info-box_text text-white">
                    <div className="icon"><i className="fab fa-twitter"></i></div>
                    <div className="details">
                      <p><a href="tel:+264812706424" className="info-box_link text-white">+ 264 81 2706424</a></p>
                    </div>
                  </div>
                  <div className="info-box_text text-white">
                    <div className="icon"><i className="fa-solid fa-envelope"></i></div>
                    <div className="details">
                      <p><a href="mailto:info@legendsafarisnamibia.com" className="info-box_link text-white">info@legendsafarisnamibia.com</a></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-xl-auto">
              <div className="flex justify-center">
                <div className="relative">
                  <div className="w-56 h-56 rounded-full mt-4 border-[2px] border-yellow-500 shadow-yellow-600 drop-shadow-lg flex items-center justify-center ">
                    <div className="text-center italic  font-serif text-lg text-yellow-500">
                      <span>Your Adventure.</span><br />
                      <span>Our Passion.</span><br />
                      <span>Unforgettable</span><br />
                      <span>Memories.</span>
                    </div>
                  </div>
                </div>
              </div></div>
          </div>
    </footer>
  );
};

export default Footer;